module.exports = __webpack_public_path__ + "img/网站3-11.a4cc6403.jpg";